module.exports = "<dc-navbar-default></dc-navbar-default>\n<main class=\"position-relative overflow-hidden\">\n  <router-outlet></router-outlet>\n</main>\n"